/**
 * @flow weak
 */

import { createSelector, createStructuredSelector } from 'reselect';
import { getUser } from '../session/getters';
import { ticket } from '../your-order/getters';
import { showGenerateInvoiceConfirmation } from '../modal/getters';

// Raw Selectors
export const flash = (state) => state.myTickets.ui.flash;
export const invoice = (state) => state.invoice;
export const created = (state) => state.invoice.created;

export const invoiceFields = createSelector(
  invoice,
  (invoice) => {
    if (!invoice) {
      return null;
    }

    const invoiceFields = Object.assign({}, invoice);
    delete invoiceFields.created;
    delete invoiceFields.id;
    return invoiceFields;
  }
);

export const missingFields = createSelector(
  invoiceFields,
  (invoiceFields) => {
    if (!invoiceFields) {
      return true;
    }

    // TaxNumber, company and stateProvice are not required some remove them
    // before we check for missing fields
    return Object.keys(invoiceFields)
      .filter(field => field !== 'taxNumber' &&  field !== 'company' &&  field !== 'stateProvince')
      .filter(field => invoiceFields[field] === '')
      .length > 0;
  }
);

export const invoiceId = createSelector(
  invoice,
  (invoice) => {
    if (invoice) {
      return invoice.id;
    }
  }
);


// connector
export default createStructuredSelector({
  user: getUser,
  flash,
  ticket,
  invoiceFields,
  missingFields,
  created,
  invoiceId,
  showGenerateInvoiceConfirmation
});



// WEBPACK FOOTER //
// ./src/modules/invoice/getters.js